<template>
    <!--开标参与人员登记-->
    <div>

        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>变更历史记录</span>
            </div>
            <template>
                <el-table
                        :data="hisListDataCopy"
                        border
                        style="width: 100%;">
                    <el-table-column width="50" label="序号" type="index" :index="indexMethodNoPage" align="center"></el-table-column>
                    <el-table-column
                            prop="personTypeName"
                            align="center"
                            width="100"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" title="查看" @click="getDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="purchaseProjectName"
                            header-align="center"
                            label="所属采购项目名称">
                    </el-table-column>
                    <el-table-column
                            prop="purchaseProjectCode"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="所属采购项目编号">
                    </el-table-column>
                    <el-table-column
                            prop="inputTime"
                            align="center"
                            width="180"
                            label="录入日期">
                    </el-table-column>
                    <el-table-column
                            prop="version"
                            align="center"
                            width="100"
                            label="版本号">
                    </el-table-column>
                </el-table>
            </template>
        </el-card>

        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>项目基本信息</span>
            </div>
            <template>
                <el-form label-width="175px" class="form viewFormWrapper" style="margin-bottom: 10px">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="所属采购项目名称：">
                                <span >{{projectInfo.purchaseProjectName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="所属采购项目编号：" >
                                <span >{{projectInfo.purchaseProjectCode || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="录入日期：" >
                                <span >{{projectInfo.inputTime || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>
        </el-card>

        <el-card class="box-card" style="margin-bottom: 10px">
            <div slot="header" class="clearfix">
                <span>开标参与人员名单</span>
            </div>
            <template>
                <el-table
                        :data="tableDataCopy"
                        border
                        style="width: 100%;">
                    <el-table-column width="50" label="序号" type="index" :index="indexMethodNoPage" align="center"></el-table-column>
                    <el-table-column
                            prop="personTypeName"
                            align="center"
                            label="人员类型">
                    </el-table-column>
                    <el-table-column
                            prop="personName"
                            align="center"
                            width="100"
                            :show-overflow-tooltip="true"
                            label="姓名">
                    </el-table-column>
                    <el-table-column
                            prop="personPhone"
                            align="center"
                            width="120"
                            :show-overflow-tooltip="true"
                            label="手机号码">
                    </el-table-column>
                    <el-table-column
                            prop="idCard"
                            align="center"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="身份证号码">
                    </el-table-column>
                    <el-table-column
                            prop="workContent"
                            align="center"
                            min-width="130"
                            :show-overflow-tooltip="true"
                            label="主要工作内容">
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            width="98"
                            label="授权书附件">
                        <template slot-scope="scope">
                            <p style="margin: 0">
                                <span  v-for="(item,index) in scope.row.attachments">
                                    <em  v-if="item.fileType == '1' && item.filePath" class="el-icon-view" style="cursor: pointer" @click="fileView(item)"></em>
                                    <em  v-if="item.fileType == '1' && item.filePath" class="el-icon-download" style="margin-left:10px;cursor: pointer" @click="fileDownload(item)"></em>
                                </span>
                            </p>

                        </template>
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            align="center"
                            width="98"
                            label="身份证附件">
                        <template slot-scope="scope">
                            <p style="margin: 0">
                                <span  v-for="(item,index) in scope.row.attachments" >
                                    <em  v-if="item.fileType == '2' && item.filePath" style="cursor: pointer" class="el-icon-view" @click="fileView(item)"></em>
                                    <em  v-if="item.fileType == '2' && item.filePath" style="margin-left:10px;cursor: pointer" class="el-icon-download" @click="fileDownload(item)"></em>
                                </span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            header-align="center"
                            v-if="nodeCodeCopy == 'CG00008'"
                            align="center"
                            width="110"
                            label="社保证明附件">
                        <template slot-scope="scope">
                            <p style="margin: 0">
                                <span  v-for="(item,index) in scope.row.attachments">
                                    <em  v-if="item.fileType == '3' && item.filePath" class="el-icon-view" style="cursor: pointer" @click="fileView(item)"></em>
                                    <em  v-if="item.fileType == '3' && item.filePath" class="el-icon-download" style="margin-left:10px;cursor: pointer" @click="fileDownload(item)"></em>
                                </span>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
                <!--                <el-pagination background-->
                <!--                               layout="sizes, prev, pager, next"-->
                <!--                               :page-sizes="[pageSize, 20, 50, 100]"-->
                <!--                               :page-size="pageSize"-->
                <!--                               :total="total"-->
                <!--                               :current-page="pageIndex"-->
                <!--                               @size-change="sizeChangeHandle"-->
                <!--                               @current-change="currentChangeHandle"></el-pagination>-->

            </template>
        </el-card>

        <!-- 附件数据 -->
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>附件列表</span>
            </div>
            <template>
                <div id="affixDown" v-if="attachmentList.length > 0">
                    <affix-doc v-for="(item,index) in attachmentList"
                               :item.sync="item"
                               :index="index"
                               :key="index"
                               :name="item.titleName">
                    </affix-doc>
                </div>
                <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
            </template>
        </el-card>

        <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
            <img :src="filePath" alt="" @contextmenu.prevent=""  class="viewImg">
        </el-dialog>
        <el-dialog :visible.sync="pdfDialogVisible" width="100%" height="100%" @closed="dialogClose">
            <iframe  :src="pdfViewer + this.filePath " frameborder="0" width="100%" height="500" @contextmenu.prevent=""></iframe>
        </el-dialog>


    </div>



</template>

<script>
    import affixDoc from '@/components/affixDoc';
    import $ from "jquery";

    export default {
        components: {
            affixDoc
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            title:{
                type:String,
                defalut:''
            },
            categoryCode:{
                type:String,
                defalut:''
            },
            total:{
                type:Number,
                defalut:0
            },
            // 变更历史
            hisListData:{
                type:Array,
                default:()=>([])
            },
            dataListLoading:{
                type:Boolean,
                defalut:false
            },
            // 是否支持附件类别约束
            categoryIsOpen:{
                type:Boolean,
                defalut:false
            },

        },
        watch:{
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
            hisListData: {
                immediate: true,
                handler (val) {
                    this.hisListDataCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
        },
        data() {
            return {
                keywords:"",
                pdfViewer:'/pdf/web/viewer.html?file=',
                pageSize:10,//每页条数
                pageIndex:1,//当前页
                projectInfo:{},
                tableDataCopy:[],
                attachmentList:[],
                hisListDataCopy:[],
                filePath:"",
                imgDialogVisible:false,
                pdfDialogVisible:false,
                nodeCodeCopy:"",
            }
        },
        created() {
            this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
        },
        activated() {

        },
        methods: {
            dialogClose() {
                this.dialogImageUrl = "";
                this.imgDialogVisible = false;
            },
            indexMethodNoPage(index) {
                return index + 1
            },
            isAssetTypeAnImage(ext){
                let arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg','tif','tiff'];
                return arr.indexOf(ext.toLowerCase()) !== -1;
            },
            isAssetTypeAnPDF(ext) {
                let arr = ['pdf', 'PDF']
                return arr.indexOf(ext.toLowerCase()) !== -1;
            },
            fileView(item){

                // 获取文件类型
                let type = item.extendName.substr(item.extendName.lastIndexOf(".")+1);
                let imgFlag = this.isAssetTypeAnImage(type);
                let pdfFlag = this.isAssetTypeAnPDF(type);

                if(pdfFlag){
                    this.imgDialogVisible = false;
                    this.pdfDialogVisible = true;
                    this.filePath = item.filePath;
                    return
                }

                if(imgFlag){

                    this.$http({
                        method:'POST',
                        url:`/attachment/getAttachmentByCiteIdAndFileType?bizid=${item.bizId}&fileType=${item.fileType}`,
                    }).then(res => {
                        if(res.data.code == '1'){
                            this.filePath = res.data.data.filePath;
                            this.imgDialogVisible = true;
                            this.pdfDialogVisible = false;
                        }
                    })


                }else{

                    this.fileDownload(item);

                }



            },
            fileDownload(item){
                if(item.filePath){
                    this.$http({
                        method:'get',
                        url:`/attachment/downloadFile?businessId=${item.bizId}&fileType=${item.fileType}&id=${item.id}`,
                        // responseType:'blob'
                    }).then(res => {
                        if(res.data.code==='1'){
                            var a = document.createElement('a');
                            a.download = this.item.name;
                            a.target="_Blank";
                            a.href = res.data.data;
                            $("body").append(a);
                            a.click();
                            $(a).remove();

                        }else{

                            this.$message({
                                type:'error',
                                message:res.data.msg
                            })

                        }

                    })
                }
            },
            getDetail(data){
                if(data){
                    let type =  this.nodeCodeCopy == 'CG00008'?'2':'1';
                    this.$http.get(`/cg/nonCustomForm/listBidOpenParticipant?purchaseProjectCode=${data.purchaseProjectCode}&version=${data.version}&type=${type}`).then(({ data }) => {
                        this.projectInfo = data.data || {};
                        this.tableDataCopy = data.data.list || [];
                    })
                    this.getAttachments(data.id)
                }else{
                    this.projectInfo = {};
                    this.tableDataCopy = [];
                    this.attachmentList = [];
                }


            },

            // 查询附件
            getAttachments(entityId){
                if(!this.categoryIsOpen){  // 不支持附件类别约束
                    this.$http.get(`/attachment/getAttachmentByBizId?bizid=${entityId}`).then(({ data }) => {
                        if (data.code == "1") {
                            this.attachmentList = data.data || [];
                            this.attachmentList.forEach((item)=>{
                                item.titleName = '相关附件'
                            })
                        } else{
                            this.attachmentList = [];
                        }
                    });

                }else{

                    this.$http.get(`/attachment/getDataByCodeAndEid?categoryCode=${this.categoryCode}&entityId=${entityId}`).then(({ data }) => {
                        if (data.code == "1") {
                            let resData= data.data;
                            if(JSON.stringify(resData) !== "{}"){
                                let arr = [];
                                for(let key in resData){
                                    data.data[key].titleName = key;
                                    arr.push(data.data[key]);
                                }
                                this.attachmentList = arr;
                            }else{
                                this.attachmentList = [];
                            }
                        } else{
                            this.attachmentList = [];
                        }
                    });
                }


            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.$emit('queryCustomFormData',{pageSize:this.pageSize,pageIndex:this.pageIndex,keywords:this.keywords})
            },
        }







    }
</script>

<style lang="less" scoped>

    .dataWrapper{
        position: relative;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 10px;
        &:last-child{
            border-bottom: none;
        }
        .iconToolbar-left{
            font-weight: bold;
            color: #fff;
            text-align: center;
            padding-top: 3px;
            position: absolute;
            top: 10px;
            left: 0px;
            width: 32px;
            height: 32px;
            background:url("../../assets/img/bookmark.png")no-repeat;
        }
    }
    .dataWrapper:last-child{
        border-bottom: none;
    }

</style>
